import React, { useState, useEffect } from 'react';
import { Line } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend } from 'chart.js';
import { Badge, Button, Card, Col, Dropdown, Form, Modal, Row, Spinner, Tab, Table, Tabs } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { fetchReservationsAll, fetchReservationsAllByidClientId, fetchReservationsAllByidUserId } from '../../actions/request/ReservationRequest';
import { fetchDamagesAll, fetchDamagesAllByUserId } from '../../actions/request/DamageRequest';
import { fetchPropertysAllByOwnerId, fetchPropertysAllResearch, fetchPropertysAllResearchAvailable, fetchPropertysAllResearchUnvailable, fetchPropertysFilters } from '../../actions/request/PropertyRequest';
import { fetchVehiclesAllByOwnerId, fetchVehiclesAllFilter, fetchVehiclesAllResearchAvailable, fetchVehiclesAllResearchUnAvailable } from '../../actions/request/VehicleRequest';
import { fetchInsurancesAll, fetchInsurancesAllByUserId } from '../../actions/request/InssuranceRequest';
import { fetchPaymentsAll } from '../../actions/request/PaymentRequest';
import moment from 'moment';
import { currentDate, profileRoleType } from '../../utils/dataApi/dataFormApi';
import { localStorageKeys } from '../../utils/storage/localvalue';
import { getAndCheckLocalStorage } from '../../utils/storage/localvalueFuction';
import { RiEye2Fill } from 'react-icons/ri';
import { ROUTES } from '../../config/routingUrl';
import { useNavigate } from 'react-router-dom';
import { MdCopyAll, MdDelete, MdDeleteOutline, MdOutlineSearch, MdOutlineWeb, MdWeb } from 'react-icons/md';
import Select from "react-select";
import { fetchMaintenancesAll } from '../../actions/request/MaintenanceRequest';
import { toast } from 'react-toastify';
import { fetchExpensessAll } from '../../actions/request/ExpenseRequest';
import { useAggregatedData } from './StatisticsReportPage';
import OccupancyRateChart from '../../components/statistiques/OccupancyRateChart';
import { exportToExcelData, exportToPDFData } from '../../utils/functionData/ExportFileDocument';
import { copyToClipboard, getCleanUrl } from '../../utils/functionData/otherFucntion';
import PatrimoineCountStatisticsCard from '../../components/statistiques/PatrimoineCountStatisticsCard';
import { fetchNotificationsAll } from '../../actions/request/NotificationRequest';
import { fetchUsersAll } from '../../actions/request/UserRequest';
import { fetchCustomersAll } from '../../actions/request/CustomerRequest';
import { fetchDepositsAll } from '../../actions/request/DepositRequest';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, BarElement, ArcElement, Title, Tooltip, Legend);

const StatisticsPage = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const deposits = useSelector((state) => state.deposits.deposits);
    const reservations = useSelector((state) => state.reservations.reservations);
    const paymentsData = useSelector((state) => state.payments.payments);
    const damages = useSelector((state) => state.damages.damages);
    const propertys = useSelector((state) => state.propertys.propertys);
    const propertysAvailables = useSelector((state) => state.propertys.propertysAvailable);
    const propertysUnAvailables = useSelector((state) => state.propertys.propertysUnAvailable);
    const vehicles = useSelector((state) => state.vehicles.vehicles);
    const vehiclesAvailables = useSelector((state) => state.vehicles.vehiclesAvailable);
    const vehiclesUnAvailables = useSelector((state) => state.vehicles.vehiclesUnAvailable);
    const insurances = useSelector((state) => state.insurances.insurances);
    const expences = useSelector((state) => state.expenses.expenses);
    const users = useSelector((state) => state.users.users);
    const customers = useSelector((state) => state.customers.customers);
    // Available






    const [propertySelect, setpropertySelect] = useState();
    const [vehicleSelect, setvehicleSelect] = useState();
    const [userSelect, setuserSelect] = useState()
    const [customerSelect, setcustomerSelect] = useState()

    const [payments, setpayments] = useState([]);


    const callFunctionElements = () => {

        setuserSelect(null);
        setvehicleSelect(null)
        setpropertySelect(null);
        setcustomerSelect(null)
        setStartDate("")
        setEndDate("")

        if (getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.USER) {
            dispatch(fetchDamagesAllByUserId(getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchInsurancesAllByUserId(getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchPropertysAllByOwnerId(getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchVehiclesAllByOwnerId(getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchPaymentsAll(startDate, endDate, customerSelect?.value, getAndCheckLocalStorage(localStorageKeys.userId) || userSelect?.value, propertySelect?.value, vehicleSelect?.value));
            dispatch(fetchExpensessAll("", "", "", "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchVehiclesAllResearchAvailable(currentDate, currentDate, getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchVehiclesAllResearchUnAvailable(currentDate, currentDate, getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchPropertysAllResearchAvailable(currentDate, currentDate, getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchPropertysAllResearchUnvailable(currentDate, currentDate, getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchNotificationsAll(getAndCheckLocalStorage(localStorageKeys.userId)));
            // deposit
            dispatch(fetchDepositsAll("", "", getAndCheckLocalStorage(localStorageKeys.userId)))
            if (getAndCheckLocalStorage(localStorageKeys.ParentSubAcount)) {
                dispatch(fetchReservationsAll("", "", "", "", "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));
            } else {
                dispatch(fetchReservationsAllByidUserId(getAndCheckLocalStorage(localStorageKeys.userId)));
            }

        } else if (getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.CUSTOMER) {
            dispatch(fetchPaymentsAll(startDate, endDate, getAndCheckLocalStorage(localStorageKeys.userId), userSelect?.value, propertySelect?.value, vehicleSelect?.value));
            dispatch(fetchReservationsAll(startDate, endDate, "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchNotificationsAll("", getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchDepositsAll("", "", "", getAndCheckLocalStorage(localStorageKeys.userId)))
        }
        else {
            dispatch(fetchDamagesAll());
            dispatch(fetchInsurancesAll());
            dispatch(fetchPropertysFilters());
            dispatch(fetchVehiclesAllFilter());
            dispatch(fetchPaymentsAll());
            dispatch(fetchReservationsAll());
            dispatch(fetchExpensessAll());
            dispatch(fetchVehiclesAllResearchAvailable(currentDate, currentDate));
            dispatch(fetchVehiclesAllResearchUnAvailable(currentDate, currentDate));
            dispatch(fetchPropertysAllResearchAvailable(currentDate, currentDate));
            dispatch(fetchPropertysAllResearchUnvailable(currentDate, currentDate));
            dispatch(fetchNotificationsAll());
            dispatch(fetchUsersAll());
            dispatch(fetchCustomersAll());
            dispatch(fetchDepositsAll());
        }
    }


    useEffect(() => {
        callFunctionElements();
    }, [dispatch]);


    useEffect(() => {
        const paymentGetData = paymentsData?.length > 0 ? paymentsData : [];
        setpayments(paymentGetData);
    }, [paymentsData]);



    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const groupByMonth = (data, field) => {
        const grouped = Array(12).fill(0);
        data.forEach(item => {
            const month = moment(item.createdAt).month();
            grouped[month] += item[field];
        });
        return grouped;
    };

    const paymentsByMonth = payments && payments.length > 0 ? groupByMonth(payments, 'amount') : [];
    const damagesAndInsurancesByMonth = expences && expences.length > 0 ? groupByMonth(expences, 'amount') : [];

    const totalDamages = expences && expences.length > 0 ? expences.reduce((sum, damage) => sum + damage.amount, 0) : 0;

    const lineChartData = {
        labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
        datasets: [
            {
                label: 'Revenus (Paiements des Réservations)',
                data: paymentsByMonth,
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
            },
            {
                label: 'Dépenses (Dommages et Assurances , Autres)',
                data: damagesAndInsurancesByMonth,
                borderColor: 'rgba(255, 99, 132, 1)',
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
            },
        ],
    };

    const lastThreeReservations = reservations ? [...reservations].slice(0, 5) : [];

    const reservationStatusCounts = (reservations) => {
        const statusCounts = { pending: 0, confirmed: 0, cancelled: 0, completed: 0 };
        reservations.forEach((reservation) => {
            if (reservation.status === 'PENDING') statusCounts.pending++;
            else if (reservation.status === 'CONFIRMED') statusCounts.confirmed++;
            else if (reservation.status === 'CANCELLED') statusCounts.cancelled++;
            else if (reservation.status === 'COMPLETED') statusCounts.completed++;
        });
        return statusCounts;
    };

    const statusCounts = reservationStatusCounts(reservations);

    const pieChartData = {
        labels: ['En attente', 'Confirmées', 'Annulées', 'Terminés'],
        datasets: [
            {
                data: [
                    statusCounts.pending,
                    statusCounts.confirmed,
                    statusCounts.cancelled,
                    statusCounts.completed
                ],
                backgroundColor: ['#FFCE56', '#36A2EB', '#FF6384', '#4BC0C0'],
                hoverBackgroundColor: ['#FFCE56', '#36A2EB', '#FF6384', '#4BC0C0'],
            },
        ],
    };



    const renderStatusBadge = (status) => {
        switch (status) {
            case 'PENDING':
                return <Badge bg="warning">En attente</Badge>;
            case 'CONFIRMED':
                return <Badge bg="success">Confirmée</Badge>;
            case 'CANCELLED':
                return <Badge bg="danger">Annulée</Badge>;
            case 'COMPLETED':
                return <Badge bg="primary">Terminée</Badge>;
            default:
                return <Badge bg="secondary">{status}</Badge>;
        }
    };



    //  filtre des option
    const vehicleOptions = vehicles && vehicles.length > 0 ? vehicles.map((item) => {
        return ({
            value: item._id, label: item.brand
        })
    }) : []

    const propertyOptions = propertys && propertys.length > 0 ? propertys.map((item) => {
        return ({
            value: item._id, label: item.name
        })
    }) : []

    const userOptions = users && users.length > 0 ? users.map((item) => {
        return ({
            value: item._id,
            label: `${item.companyName || ""} ${item.email || ""} ${item.firstname || ""} ${item.lastname || ""} `.trim()
        })
    }) : []

    const customerOptions = customers && customers.length > 0 ? customers.map((item) => {
        return ({
            value: item._id,
            label: `${item.email || ""} ${item.firstname || ""} ${item.lastname || ""}`.trim()
        })
    }) : []




    const [showLoading, setshowLoading] = useState(false);
    const handleShowLoading = () => { setshowLoading(true) }
    const handleCloseLoading = () => { setshowLoading(false) }


    // function filter
    const handleSearchFilter = () => {
        handleShowLoading();
        if (getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.USER) {
            // administrateur de la plateforme en question

            dispatch(fetchReservationsAll(
                startDate, endDate, propertySelect?.value, vehicleSelect?.value, "", "", getAndCheckLocalStorage(localStorageKeys.userId)
            ))
            dispatch(fetchPaymentsAll(startDate, endDate, "", getAndCheckLocalStorage(localStorageKeys.userId), propertySelect?.value, vehicleSelect?.value))
            const paymentGetData = paymentsData?.length > 0 ? paymentsData : [];
            setpayments(paymentGetData);
            dispatch(fetchMaintenancesAll(getAndCheckLocalStorage(localStorageKeys.userId), startDate, endDate, propertySelect?.value, vehicleSelect?.valeu));
            dispatch(fetchExpensessAll(startDate, endDate, "", "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));

            // dispatch(fetchVehiclesAllFilter("", "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));
            // dispatch(fetchPropertysAllResearch("", "", getAndCheckLocalStorage(localStorageKeys.userId)));


            dispatch(fetchVehiclesAllResearchAvailable(startDate, endDate, getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchVehiclesAllResearchUnAvailable(startDate, endDate, getAndCheckLocalStorage(localStorageKeys.userId)));

            dispatch(fetchPropertysAllResearchAvailable(startDate, endDate, getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchPropertysAllResearchUnvailable(startDate, endDate, getAndCheckLocalStorage(localStorageKeys.userId)));
            dispatch(fetchDepositsAll(startDate, endDate, getAndCheckLocalStorage(localStorageKeys.userId)))

            if (!getAndCheckLocalStorage(localStorageKeys.ParentSubAcount)) {
                dispatch(fetchReservationsAllByidUserId(
                    getAndCheckLocalStorage(localStorageKeys.userId),
                    startDate, endDate, propertySelect?.value, vehicleSelect?.value, ""
                ))
            } else {
                dispatch(fetchReservationsAll(startDate, endDate, "", "", "", "", "", getAndCheckLocalStorage(localStorageKeys.userId)));
            }
        } else if (getAndCheckLocalStorage(localStorageKeys.profileRole) === profileRoleType.CUSTOMER) {
            dispatch(fetchReservationsAllByidClientId(
                getAndCheckLocalStorage(localStorageKeys.userId),
                startDate, endDate, propertySelect?.value, vehicleSelect?.value, ""
            ));
            dispatch(fetchDepositsAll(startDate, endDate, "", getAndCheckLocalStorage(localStorageKeys.userId)))
            dispatch(fetchPaymentsAll(startDate, endDate, getAndCheckLocalStorage(localStorageKeys.userId)))
            const paymentGetData = paymentsData?.length > 0 ? paymentsData : []
            setpayments(paymentGetData);
        }
        else {
            dispatch(fetchReservationsAll(startDate, endDate, propertySelect?.value, vehicleSelect?.value, "", customerSelect?.value, userSelect?.value));
            dispatch(fetchPaymentsAll(startDate, endDate, customerSelect?.value, userSelect?.value, propertySelect?.value, vehicleSelect?.value));
            const paymentGetData = paymentsData?.length > 0 ? paymentsData : [];
            setpayments(paymentGetData);
            dispatch(fetchNotificationsAll(userSelect?.value, customerSelect?.value, vehicleSelect?.value, propertySelect?.value, "", "", "", startDate, endDate, "", "", userSelect?.value));
            dispatch(fetchPropertysFilters(startDate, endDate, "", "", userSelect?.value));
            dispatch(fetchVehiclesAllFilter(startDate, endDate, "", "", userSelect?.value));
            dispatch(fetchMaintenancesAll(userSelect?.value, startDate, endDate, propertySelect?.value, vehicleSelect?.valeu));
            dispatch(fetchExpensessAll(startDate, endDate, "", "", "", "", userSelect?.value));
            dispatch(fetchVehiclesAllResearchAvailable(startDate, endDate, userSelect?.value));
            dispatch(fetchVehiclesAllResearchUnAvailable(startDate, endDate, userSelect?.value));
            dispatch(fetchPropertysAllResearchAvailable(startDate, endDate, userSelect?.value));
            dispatch(fetchPropertysAllResearchUnvailable(startDate, endDate, userSelect?.value));
            dispatch(fetchDepositsAll(startDate, endDate, userSelect?.value, customerOptions?.value))
        }
        handleCloseLoading();
    }


    const [showWebSite, setshowWebSite] = useState(false);
    const handleShowWebsite = () => { setshowWebSite(true) }
    const handleCloseWebsite = () => { setshowWebSite(false) }
















    const aggregatedData = useAggregatedData();
    // Calcul des totaux
    const totals = aggregatedData.reduce(
        (acc, entry) => {
            acc.totalPayments += entry.totalPayments;
            acc.totalExpenses += entry.totalExpenses;
            acc.totalDaysReserved += entry.totalDaysReserved;
            acc.totalDaysInReservationMonths += entry.totalDaysInReservationMonths; // Total des jours concernés par les mois
            acc.clientsCount += entry.clientsCount;
            return acc;
        },
        {
            totalPayments: 0,
            totalExpenses: 0,
            totalDaysReserved: 0,
            totalDaysInReservationMonths: 0, // Nouveau champ
            clientsCount: 0,
        }
    );

    // Nouvelle fonction de calcul du taux d'occupation total
    const calculateOccupancyRate = (totalDaysReserved, totalDaysInReservationMonths) => {
        // Calculer le taux d'occupation en fonction des jours réservés et des jours concernés
        return (totalDaysReserved / totalDaysInReservationMonths) * 100;
    };

    // Utilisation dans votre composant
    const totalOccupancyRate = calculateOccupancyRate(
        totals.totalDaysReserved,
        totals.totalDaysInReservationMonths
    );


    // Fonction pour compter les réservations confirmées
    const countConfirmedReservations = () => {
        return reservations.filter(reservation => reservation.status === 'CONFIRMED').length || 0;
    };

    // Fonction pour compter les réservations en cours
    const countOngoingReservations = () => {
        return reservations.filter(reservation => reservation.status === 'PENDING').length || 0; // Assurez-vous que 'IN_PROGRESS' est le bon statut utilisé
    };

    // Fonction pour compter les réservations terminées
    const countCompletedReservations = () => {
        return reservations.filter(reservation => reservation.status === 'COMPLETED').length || 0;
    };

    const countCancelledReservations = () => {
        return reservations.filter(reservation => reservation.status === 'CANCELLED').length || 0;
    };

    // Utilisation des fonctions dans le composant
    const totalConfirmedReservations = countConfirmedReservations();
    const totalOngoingReservations = countOngoingReservations();
    const totalCompletedReservations = countCompletedReservations();
    const totalCancelledReservations = countCancelledReservations();



    // Fonction pour calculer la somme totale des dépôts en cours (PENDING)
    const sumOngoingDeposits = () => {
        return deposits
            .filter(deposit => deposit.status === 'PENDING') // Filtrer les dépôts avec le statut "PENDING"
            .reduce((total, deposit) => total + (deposit.amount || 0), 0); // Additionner les montants
    };

    // Fonction pour calculer la somme totale des dépôts complétés (COMPLETED)
    const sumCompletedDeposits = () => {
        return deposits
            .filter(deposit => deposit.status === 'COMPLETED') // Filtrer les dépôts avec le statut "COMPLETED"
            .reduce((total, deposit) => total + (deposit.amount || 0), 0); // Additionner les montants
    };

    // Utilisation des fonctions dans le composant
    const totalOngoingAmount = sumOngoingDeposits(); // Somme totale des dépôts en cours
    const totalCompletedAmount = sumCompletedDeposits(); // Somme totale des dépôts complétés










    return (
        <div className="">


            {/* Filtres pour les dates */}
            {<Card className="mb-4">
                <Card.Header>
                    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
                        <div>
                            <h3 className="mb-4">Tableau de bord </h3>
                        </div>
                        <div>
                            {
                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ?
                                    <Button size="sm" variant='primary' onClick={handleShowWebsite} ><MdOutlineWeb /> <span>Site web</span></Button>
                                    : ""
                            }
                        </div>
                    </div>

                </Card.Header>
                <Card.Body>
                    {
                        (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ||
                            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.CUSTOMER ||
                            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT
                        ) ?
                            <ul className="list-group">
                                <li className="list-group-item rounded-lg" style={{ display: "flex", flexWrap: "wrap", width: "100%", justifyContent: "space-between" }}>
                                    <div className="flex" style={{ display: "flex", flexWrap: "wrap", maxWidth: "100%" }}>

                                        {
                                            (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ||
                                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                                                getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT
                                            ) && (<Form>
                                                <Row>
                                                    {
                                                        !getAndCheckLocalStorage(localStorageKeys.ParentSubAcount) && (
                                                            <Col md={3}>
                                                                <Form.Group controlId="startHour" style={{ minWidth: "200px" }}>
                                                                    <Form.Label>Véhicule</Form.Label>
                                                                    <Select
                                                                        value={vehicleSelect}
                                                                        onChange={(selectedOption) => setvehicleSelect(selectedOption)}
                                                                        options={vehicleOptions}
                                                                        isClearable
                                                                        isSearchable
                                                                        placeholder="Choix"
                                                                        isDisabled={!!propertySelect}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        )
                                                    }

                                                    {
                                                        !getAndCheckLocalStorage(localStorageKeys.ParentSubAcount) && (
                                                            <Col md={3}>
                                                                <Form.Group controlId="startHour" style={{ minWidth: "200px" }}>
                                                                    <Form.Label>Propriété</Form.Label>
                                                                    <Select
                                                                        value={propertySelect}
                                                                        isClearable
                                                                        isSearchable
                                                                        onChange={(selectedOption) => setpropertySelect(selectedOption)}
                                                                        options={propertyOptions}
                                                                        placeholder="Choix"
                                                                        isDisabled={!!vehicleSelect}

                                                                    />
                                                                </Form.Group>
                                                            </Col>)
                                                    }
                                                    {(
                                                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                                                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT ||
                                                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN) &&
                                                        (
                                                            <Col md={3}>
                                                                <Form.Group controlId="startHour" style={{ minWidth: "200px" }}>
                                                                    <Form.Label>Agence</Form.Label>
                                                                    <Select
                                                                        value={userSelect}
                                                                        isClearable
                                                                        isSearchable
                                                                        onChange={(selectedOption) => setuserSelect(selectedOption)}
                                                                        options={userOptions}
                                                                        placeholder="Choix"
                                                                        isDisabled={!!customerSelect}
                                                                    />
                                                                </Form.Group>
                                                            </Col>)
                                                    }
                                                    {
                                                        (
                                                            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                                                            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT ||
                                                            getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN)
                                                        &&
                                                        (
                                                            <Col md={3}>
                                                                <Form.Group controlId="startHour" style={{ minWidth: "200px" }}>
                                                                    <Form.Label>Clients</Form.Label>
                                                                    <Select
                                                                        value={customerSelect}
                                                                        isClearable
                                                                        isSearchable
                                                                        onChange={(selectedOption) => setcustomerSelect(selectedOption)}
                                                                        options={customerOptions}
                                                                        placeholder="Choix"
                                                                        isDisabled={!!userSelect}
                                                                    />
                                                                </Form.Group>
                                                            </Col>
                                                        )
                                                    }

                                                </Row>
                                            </Form>
                                            )
                                        }

                                    </div>
                                    <div style={{ display: "flex", flexWrap: "wrap" }}>
                                        <div className="p-1">
                                            <label>{""}</label>
                                            <input type="date" placeholer="début" style={{ height: "40px" }} className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
                                        </div>
                                        <div className="p-1">
                                            <label>{""}</label>
                                            <input type="date" placeholder='fin' style={{ height: "40px" }} className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
                                        </div>
                                        <div className="m-1">
                                            <label>{""}</label>
                                            <div className="spacer">
                                                <Button variant='primary' size='sm' clasName="m-1" onClick={handleSearchFilter} >
                                                    <MdOutlineSearch />
                                                </Button>
                                                {
                                                    (
                                                        userSelect || vehicleSelect || propertySelect || customerSelect || startDate || endDate
                                                    ) && (
                                                        <Button variant="danger" size="sm" className="m-1 text-white" onClick={callFunctionElements}>
                                                            <MdDeleteOutline /> Effacer
                                                        </Button>
                                                    )
                                                }
                                            </div>

                                        </div>

                                    </div>
                                </li>
                            </ul>
                            : ""
                    }

                </Card.Body>
            </Card>
            }

            {/* Cartes des statistiques */}
            <Row>

                <Col md={3}>
                    <Card className="mb-4 border rounded-lg shadow-sm">
                        <Card.Body>
                            <p className="card-text"><strong>Réservations</strong></p>
                            <hr />
                            <p className="card-text text-lg">
                                <div className="card-text text-lg" style={{ display: "flex", flexDirection: "row" }}>
                                    <div>
                                        <span style={{ fontSize: "20px" }}>{reservations && reservations.length > 0 ?
                                            Number(reservations.length) : "0"}</span>
                                    </div>
                                    <div style={{ display: "flex", flexWrap: "wrap" }} >

                                        {reservations && reservations.length > 0 && totalOngoingReservations > 0 && (<div><Badge bg="warning" className="text-white m-1"> {totalOngoingReservations} En cours </Badge> </div>)}
                                        {reservations && reservations.length > 0 && totalConfirmedReservations > 0 && (<div><Badge bg="success" className="text-white m-1"> {totalConfirmedReservations} Confirmée(s) </Badge> </div>)}
                                        {reservations && reservations.length > 0 && totalCompletedReservations > 0 && (<div><Badge bg="primary" className="text-white m-1"> {totalCompletedReservations} Terminée(s) </Badge> </div>)}
                                        {reservations && reservations.length > 0 && totalCancelledReservations > 0 && (<div><Badge bg="danger" className="text-white m-1"> {totalCancelledReservations} Anulée(s) </Badge> </div>)}

                                    </div>
                                </div>

                            </p>
                        </Card.Body>
                    </Card>
                </Col>

                <Col md={3}>
                    <Card className="mb-4 border rounded-lg shadow-sm">
                        <Card.Body>
                            <p className="card-text"><strong>Jours</strong></p>
                            <hr />
                            <p className="card-text text-lg" style={{ fontSize: "20px" }}>
                                {
                                    totals?.totalDaysReserved?.toFixed(0)
                                } Jours
                            </p>
                        </Card.Body>
                    </Card>
                </Col>






                {
                    (!getAndCheckLocalStorage(localStorageKeys.ParentSubAcount)) && (
                        <Col md={3}>
                            <Card className="mb-4 border rounded-lg shadow-sm">
                                <Card.Body>
                                    <p className="card-text"><strong>Paiements</strong></p>
                                    <hr />
                                    <p className="card-text text-lg">
                                        {

                                            payments && payments.length > 0 ?

                                                Number(payments.reduce((sum, payment) => sum + payment.amount, 0)).toFixed(2)
                                                : 0
                                        } DZD
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>
                    )
                }

                {
                    (!getAndCheckLocalStorage(localStorageKeys.ParentSubAcount)) &&
                    (
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT

                    ) && (
                        <Col md={3}>
                            <Card className="mb-4 border rounded-lg shadow-sm">
                                <Card.Body>
                                    <p className="card-text"><strong>Dépenses</strong></p>
                                    <hr />
                                    <p className="card-text text-lg">{totalDamages} DZD</p>
                                </Card.Body>
                            </Card>
                        </Col>)
                }

                {
                    (!getAndCheckLocalStorage(localStorageKeys.ParentSubAcount)) &&
                    (
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT

                    ) &&
                    (
                        <Col md={3}>
                            <Card className="mb-4 border rounded-lg shadow-sm">
                                <Card.Body>
                                    <p className="card-text"><strong> Patrimoine </strong></p>
                                    <hr />
                                    <p className="card-text text-lg">
                                        <span className="text-lg" style={{ fontSize: "20px" }}>{vehicles && vehicles.length > 0 ? vehicles.length : "0"}</span><strong> véhicules </strong>
                                        <span className="text-lg" style={{ fontSize: "20px" }}>{propertys && propertys.length > 0 ? propertys.length : "0"}</span><strong> propriétés </strong></p>
                                </Card.Body>
                            </Card>
                        </Col>)
                }

                {
                    (!getAndCheckLocalStorage(localStorageKeys.ParentSubAcount)) &&
                    (
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT

                    ) &&
                    (
                        <Col md={3}>
                            <Card className="mb-4 border rounded-lg shadow-sm">
                                <Card.Body>
                                    <p className="card-text"><strong> Véhicules en mouvement </strong></p>
                                    <hr />
                                    <p className="card-text text-lg">
                                        <span className="text-lg text-danger" style={{ fontSize: "20px" }}>{vehiclesUnAvailables && vehiclesUnAvailables.length > 0 ? vehiclesUnAvailables.length : "0"}</span><strong className="text-danger"> Loués </strong>
                                        <span className="text-lg text-success" style={{ fontSize: "20px" }}>{vehiclesAvailables && vehiclesAvailables.length > 0 ? vehiclesAvailables.length : "0"}</span><strong className="text-success"> non loués </strong></p>
                                </Card.Body>
                            </Card>
                        </Col>)
                }
                {
                    (!getAndCheckLocalStorage(localStorageKeys.ParentSubAcount)) &&

                    (
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT

                    ) &&
                    (
                        <Col md={3}>
                            <Card className="mb-4 border rounded-lg shadow-sm">
                                <Card.Body>
                                    <p className="card-text"><strong> Propriétés en mouvement </strong></p>
                                    <hr />
                                    <p className="card-text text-lg">
                                        <span className="text-lg text-danger" style={{ fontSize: "20px" }}>{propertysUnAvailables && propertysUnAvailables.length > 0 ? propertysUnAvailables.length : "0"}</span><strong className="text-danger"> louées </strong>
                                        <span className="text-lg text-success" style={{ fontSize: "20px" }}>{propertysAvailables && propertysAvailables.length > 0 ? propertysAvailables.length : "0"}</span><strong className="text-success"> non louées </strong></p>
                                </Card.Body>
                            </Card>
                        </Col>)
                }
                {
                    (!getAndCheckLocalStorage(localStorageKeys.ParentSubAcount))
                    && (
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.CUSTOMER ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT
                    )
                    && (

                        <Col md={3}>
                            <Card className="mb-4 border rounded-lg shadow-sm">
                                <Card.Body>
                                    <p className="card-text"><strong>Accompte (€uro)</strong></p>
                                    <hr />
                                    <p className="card-text text-lg">
                                        <div className="card-text text-lg" style={{ display: "flex", flexDirection: "row" }}>
                                            <div>
                                                {/* Afficher le total des dépôts avec 4 chiffres après la virgule */}
                                                <span style={{ fontSize: "20px" }}>
                                                    {deposits && deposits.length > 0
                                                        ? Number(deposits.reduce((total, deposit) => total + (deposit.amount || 0), 0)).toFixed(2)
                                                        : "0.0000"}
                                                </span>
                                            </div>
                                            <div style={{ display: "flex", flexWrap: "wrap" }}>
                                                {/* Afficher les montants en cours et complétés avec 4 chiffres après la virgule */}
                                                <div>
                                                    <Badge bg="danger" className="text-white m-1">
                                                        Impayé  {totalOngoingAmount.toFixed(2)}
                                                    </Badge>
                                                </div>
                                                <div>
                                                    <Badge bg="primary" className="text-white m-1">
                                                        Payé : {totalCompletedAmount.toFixed(2)}
                                                    </Badge>
                                                </div>
                                            </div>
                                        </div>
                                    </p>
                                </Card.Body>
                            </Card>
                        </Col>

                    )
                }



            </Row>

            {
                (!getAndCheckLocalStorage(localStorageKeys.ParentSubAcount)) &&
                (
                    getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ||
                    getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                    getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                    getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT

                ) &&
                <PatrimoineCountStatisticsCard />

            }



            {/* Affichage des 3 dernières réservations */}
            <Card className="mt-4 p-3  border rounded-lg shadow-sm">
                <Card.Body>
                    {
                        lastThreeReservations && lastThreeReservations.length > 0 ?
                            <>
                                <div className="mb-5" style={{ display: "flex", flexWrap: "wrap", width: "100%", justifyContent: "space-between" }}>
                                    <div><h6 className="">Réservations récentes</h6></div>
                                    <div><span className="text-link text-primary text-text-decoration-underline pointer-event" style={{ cursor: "pointer" }} size="sm" title="Listes des reservations"
                                        onClick={() => { navigate(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATIONS_REQUEST_LIST}`) }}
                                    >Voire plus</span></div>
                                </div>

                                <ul className="list-group">

                                    {lastThreeReservations.map(reservation => (
                                        <li key={reservation._id} className="list-group-item" style={{ display: "flex", flexWrap: "wrap", width: "100%", justifyContent: "space-between" }}>
                                            <div>
                                                <strong>{reservation?.ordre || ""}</strong> <strong style={{ fontWeight: "bold" }}> {reservation.property?.name || ""}  {reservation?.vehicle?.brand || ""} </strong> - {moment(reservation.createdAt).format('DD MMM YYYY')}
                                                {renderStatusBadge(reservation.status)}
                                            </div>
                                            <div>
                                                <Button variant='primary' size='sm'
                                                    onClick={() => { navigate(`/${ROUTES.DASHBOARD}/${ROUTES.RESERVATION_VIEW}/${reservation._id}`) }}
                                                ><RiEye2Fill /></Button>
                                            </div>
                                        </li>
                                    ))}
                                </ul>
                            </> :
                            <>

                            </>

                    }
                    {/*<div className="text-center" style={{ width: "100%", height: "150px", justifyContent: "center" }}>
                                Aucune réservation
                            </div> */}
                </Card.Body>
            </Card>

            {/* Graphiques */}
            <Row>
                {/*
                    reservations && reservations.length > 0 ?
                        <Col md={6}>
                            <Card className="mb-4">
                                <Card.Body>
                                    <h6>Réservations par État</h6>
                                    <Pie data={pieChartData} />
                                </Card.Body>
                            </Card>
                        </Col> : ""
                         */
                }

                {

                    (
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPER_ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.ADMIN ||
                        getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.SUPPORT

                    ) &&

                    <Tabs defaultActiveKey="payment_expenses" id="reservation-details-tabs" className="mb-3">
                        {
                            !getAndCheckLocalStorage(localStorageKeys.ParentSubAcount) &&
                            (
                                <Tab eventKey="payment_expenses" title="Paiements et dépenses" className="p-3 border rounded-lg shadow-sm">
                                    {
                                        (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER || profileRoleType.SUPER_ADMIN | profileRoleType.ADMIN || profileRoleType.SUPPORT) &&
                                        (reservations && reservations.length > 0 || expences && expences.length > 0) &&
                                        (
                                            <Col md={12}>
                                                <Card className="mb-4">
                                                    <Card.Body>
                                                        <h6>Revenus et Dépenses</h6>
                                                        <Line data={lineChartData} />
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                    }
                                </Tab>
                            )
                        }

                        {
                            !getAndCheckLocalStorage(localStorageKeys.ParentSubAcount) &&
                            (
                                <Tab eventKey="occupacity_vehicle" title="Graphique du taux d'occupation" className="p-3 border rounded-lg shadow-sm">
                                    {
                                        (getAndCheckLocalStorage(localStorageKeys.profileRole) == profileRoleType.USER || profileRoleType.SUPER_ADMIN | profileRoleType.ADMIN || profileRoleType.SUPPORT) &&
                                        (reservations && reservations.length > 0 || expences && expences.length > 0) &&
                                        (
                                            <Col md={12}>
                                                <Card className="mb-4">
                                                    <Card.Body>
                                                        <OccupancyRateChart data={aggregatedData} type={"vehicle"} />
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                        )
                                    }
                                </Tab>
                            )
                        }




                    </Tabs>

                }

            </Row>




            <Modal show={showLoading} size='sm' onHide={handleCloseLoading} centered style={{ background: "transparent" }}>
                <Modal.Body>
                    <div style={{ height: "100%", width: "100%", display: "flex", justifyContent: "center", alignContent: "center" }}>
                        <div><Spinner variant='primary' /></div>
                    </div>
                </Modal.Body>
            </Modal>


            <Modal show={showWebSite} onHide={handleCloseWebsite} centered>
                <Modal.Body>
                    <div style={{ width: "100%" }}>
                        <div className="form-group mb-3">
                            <label htmlFor="password" className="form-label">Url Site web</label>
                            <div className="input-group">
                                <input style={{ height: "40px" }}
                                    readOnly
                                    className={`form-control`}
                                    placeholder=""
                                    value={
                                        `${getCleanUrl()}${`/${ROUTES.CAR_DETAIL_USER_PATRIMOINE_LIST}/${getAndCheckLocalStorage(localStorageKeys.userId) || ""}/person-or-company/${getAndCheckLocalStorage(localStorageKeys.userId) || ""}`}`
                                    }
                                />
                                <button
                                    type="button" style={{ height: "40px" }}
                                    className="btn btn-sm btn-outline-primary"
                                    onClick={() => {
                                        copyToClipboard(
                                            `${getCleanUrl()}${`/${ROUTES.CAR_DETAIL_USER_PATRIMOINE_LIST}/${getAndCheckLocalStorage(localStorageKeys.userId) || ""}/person-or-company/${getAndCheckLocalStorage(localStorageKeys.userId) || ""}`}`
                                        )
                                        setshowWebSite(false);
                                    }}
                                >
                                    <MdCopyAll />
                                </button>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>



        </div>
    );
};

export default StatisticsPage;
